/**
 * Compact display form of an event id for tight UI (the inbox row's id chip).
 *
 * Real Work Queue ids are UUIDs (36 chars) that overflow the row, so we show the
 * first UUID segment (8 chars) + an ellipsis — matching the `refId`/shortRef
 * short form used in the detail header, so list and detail stay consistent. Short
 * ids (e.g. mock `EVT-001`) are returned unchanged. Callers keep the full id in a
 * `title` tooltip.
 */
export function shortEventId(id) {
  if (!id) return '';
  const s = String(id);
  return s.length > 12 ? `${s.slice(0, 8)}…` : s;
}
